import axios from "axios";
import {
	limparFalhaDeCarga,
	registrarSeFalhaDeCarga,
} from "./falhaCarga";

export const BASE_URL =
	process.env.REACT_APP_API_HOST || "http://localhost:3005";

const api = axios.create({
	baseURL: BASE_URL,
	// Timeout default para evitar request pendurado indefinidamente.
	// 60s cobre relatórios/exports pesados; chamadas curtas não esperam tudo.
	timeout: 60_000,
	withCredentials: true,
});

// Interceptor para tratar erros de autenticação e capturar novos tokens
api.interceptors.response.use(
	(response) => {
		// #1696: carga que voltou apaga o aviso de falha.
		limparFalhaDeCarga();
		return response;
	},
	(error) => {
		registrarSeFalhaDeCarga(error);

		if (error.response?.status === 401) {
			// Não remove cookie automaticamente — deixa o AuthContext decidir.
			// Remover aqui causava race condition no F5 (múltiplas chamadas
			// simultâneas, uma falha remove o cookie das outras).
		}

		// ✅ Suprimir log de erro 409 para criação de reposições (idempotência esperada)
		if (
			error.response?.status === 409 &&
			error.config?.url?.includes("/criar-reposicoes/")
		) {
			// Não logar erro 409 para criação de reposições - é idempotência esperada
			// A função gerarReposicoesNota já trata isso adequadamente
		}

		return Promise.reject(error);
	},
);

export default api;
